import React from 'react';
import { useTranslation } from 'react-i18next';
import { useInstance } from 'react-ioc';
import { useNavigate } from 'react-router-dom';
import { Button, Form, Input, message } from 'antd';
import { useLoginMutation } from 'generated/graphql';
import { observer } from 'mobx-react-lite';
import { Store } from 'model/store/Store';
import { FORGET_PASSWORD, REGISTER } from 'routes';

interface IFormState {
  identifier: string,
  password: string,
}

interface ILogin {
  afterLogin?: () => void;
}

export const Login = observer(({ afterLogin }: ILogin) => {

  const [loginMutation, loginData] = useLoginMutation();
  const store = useInstance(Store);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onSubmit = async (values: IFormState) => {
    await loginMutation({
      variables: {
        input: {
          identifier: values.identifier,
          password: values.password
        }
      },
      onCompleted: (data: any) => {
        const jwt = data?.login.jwt;
        const userId = data?.login.user.id;
        store.auth.setTokenAndId(jwt, userId);
        store.domain.clearState();
        if (afterLogin) {
          afterLogin();
        }
      },
      onError: (error) => {
        message.error(error.message);
      }
    });
  };

  return (

    <Form layout="vertical"
          onFinish={onSubmit}
          scrollToFirstError
          disabled={loginData.loading}
    >

      <Form.Item name="identifier" label={t('Email')}
                 rules={[
                   { required: true, message: t('Required')! },
                   { type: 'email', message: t('Invalid format')! }
                 ]}
      >
        <Input placeholder="example@site.com" />
      </Form.Item>

      <Form.Item name="password" label={t('Password')}
                 rules={[
                   { required: true, message: `${t('Required')}` }
                 ]}
      >
        <Input.Password />
      </Form.Item>

      <Form.Item>
        <Button loading={loginData.loading} block htmlType={'submit'} type="primary">{t('Login')}</Button>
      </Form.Item>

      <Button block type={'link'} onClick={() => navigate(FORGET_PASSWORD)}>{t('Forgot your password?')}</Button>
      <Button block type={'link'} onClick={() => navigate(REGISTER)}>{t('Create Account')}</Button>

    </Form>

  );
})